export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'garanceBreadcrumbTODO';
export const NAME = 'Garance';
